import { CantileverButton } from 'components/CantileverButton'
import { useKestrelViewerContext } from 'features/kestrelViewer/KestrelViewerProvider'
import React, { useEffect } from 'react'

import {
  ButtonContainer,
  PhotoReelTooltipContainer,
  TooltipArrowDown,
  TooltipBox,
  TooltipText,
  TooltipTitle,
} from './TutorialStyledComponents'

interface PhotoReelTooltipProps {
  onNext: () => void
  onPrevious: () => void
}

export const PhotoReelTooltip: React.FC<PhotoReelTooltipProps> = ({
  onNext,
  onPrevious,
}) => {
  const { setPhotoReelOpen } = useKestrelViewerContext()

  const handleNext = () => {
    setPhotoReelOpen(false)
    onNext()
  }

  const handlePrevious = () => {
    setPhotoReelOpen(false)
    onPrevious()
  }

  useEffect(() => {
    setPhotoReelOpen(true)
    // close photoreel when component unmounts
    return () => {
      setPhotoReelOpen(false)
    }
  }, [setPhotoReelOpen])

  return (
    <PhotoReelTooltipContainer>
      <TooltipBox style={{ maxWidth: '50rem', width: '50rem' }}>
        <TooltipArrowDown />
        <TooltipTitle>Photo Reel</TooltipTitle>
        <TooltipText>
          The photo reel will show you all of the original photos used to create
          the model if they have been uploaded. By default, when you are
          orbiting around a point, the photo reel will filter to show you all
          the photos that include the current orbit point and where that point
          in the photo.
        </TooltipText>
        <ButtonContainer style={{ marginTop: '1rem' }}>
          <CantileverButton onClick={handlePrevious}>Previous</CantileverButton>
          <CantileverButton primary onClick={handleNext}>
            Next
          </CantileverButton>
        </ButtonContainer>
      </TooltipBox>
    </PhotoReelTooltipContainer>
  )
}
